import { Flex, Space } from "antd";
import { useTranslation } from "react-i18next";
import { AppForm, AppButton, AppParagraph } from "@/shared/Components";
import { FormInputPassword } from "@/shared/Components/Form/FormInputs/FormInputPassword";
import type { NewPasswordFormProps } from "@/entities/new-password-form/model";
import styles from "./styles.module.scss";

export const Mobile = ({
  formApi,
  handleSubmit,
  handleCancel,
  submitDisabled,
  isLoading,
}: NewPasswordFormProps) => {
  const { t } = useTranslation();

  return (
    <AppForm className={styles.form} formApi={formApi} onSubmit={handleSubmit}>
      <Flex gap={32} vertical>
        <Space direction="vertical">
          <FormInputPassword
            placeholder={t("registrationPage.userInfoStep.password")}
            name="password"
            className={styles["registration-input"]}
          />
          <FormInputPassword
            placeholder={t("registrationPage.userInfoStep.confirmPassword")}
            name="confirmPassword"
            className={styles["registration-input"]}
          />
          <AppParagraph size="sm" className={styles.subtitle}>
            {t("registrationPage.userInfoStep.passwordMustContain")}
          </AppParagraph>
        </Space>
        <Flex className={styles.buttons} justify="space-between" gap={8}>
          <AppButton
            type="link"
            className={styles.cancel}
            onClick={handleCancel}
            loading={isLoading}
          >
            {t("common.cancel")}
          </AppButton>
          <AppButton
            htmlType="submit"
            type="primary"
            className={styles.submit}
            disabled={submitDisabled}
            loading={isLoading}
          >
            {t("passwordRecoveryPage.confirm")}
          </AppButton>
        </Flex>
      </Flex>
    </AppForm>
  );
};
